
export const OrderPlaced = ()=>{
    return(
         <div>
              <img  src="https://dealsnaijashop.com/wp-content/uploads/2020/09/icon_confirmation-1.gif" alt="" />
         </div>
    )
}